import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { Item } from '../item';
import { Header } from '../header';

interface Props {
  title: string;
  onClick: () => void;
}
export const SlidingItem = ({ title, onClick }: Props) => (
  <Item>
    <Header onClick={onClick}>
      {title}
      <IconArrow size="small" />
    </Header>
  </Item>
);
